import {
  INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS,
  INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS} from './constant'

export function subscriptionStatus () {
  return { type: INVENTORY_INGREDIENT_SUBSCRIPTION_STATUS }
}

export function setSubscriptionStatus (status) {
  return { type: INVENTORY_INGREDIENT_SET_SUBSCRIPTION_STATUS, payload: {status} }
}



// WEBPACK FOOTER //
// ./app/actions/inventory/ingredientSubscription/index.js